<template>
  <ul id="time-picker" ref="timePicker" :class="style['bottom-panel-timer']">
    <li
      v-for="(time, index) in timeList"
      :ref="addSelectedClass(time) ? 'defaultSelected' : undefined"
      :class="addSelectedClass(time)"
      @click="updateSelectedTime(extractSpace(time))"
    >
      {{ time }}
    </li>
  </ul>
</template>

<script>
import style from '../scss/_bottompanel.scss'
import createTimeList, { extractSpace } from 'Utilities/TimerHelper'
import { useDatepickerStore } from 'Store/datepicker'

export default {
  setup() {
    return {
      datepickerStore: useDatepickerStore()
    }
  },

  props: {
    selectedTime: String,
    updateSelectedTime: Function,
    selectedDate: String,
    timeLimited: Array,
    enabledTimes: Array
  },
  data() {
    return {
      style
    }
  },
  computed: {
    defaultHourIncrement() {
      return this.datepickerStore.settings.defaultHourIncrement
    },
    defaultMinuteIncrement() {
      return this.datepickerStore.settings.defaultMinuteIncrement
    },
    timeList() {
      let options = null

      if (this.enabledTimes) return this.enabledTimes

      if (this.timeLimited && this.timeLimited.length > 0) {
        this.timeLimited.some((timeRange) => {
          const selectedDateFormat = new Date(this.selectedDate).getTime()
          if (
            new Date(timeRange.start_date).getTime() <= selectedDateFormat &&
            selectedDateFormat <= new Date(timeRange.end_date).getTime()
          ) {
            options = {
              startTime: timeRange.start_time,
              endTime: timeRange.end_time
            }
          }
        })
      }
      return createTimeList(this.defaultHourIncrement, this.defaultMinuteIncrement, options)
    }
  },
  mounted() {
    const dom = this.$refs.defaultSelected
    const offsetTop =
      (dom && dom[0] && dom[0].offsetTop - 175) || this.$refs.timePicker.scrollHeight / 2 - 175
    this.$refs.timePicker.scroll(0, offsetTop)
  },
  methods: {
    addSelectedClass(time) {
      return extractSpace(time) === this.selectedTime && style['selected']
    },
    extractSpace
  }
}
</script>
